import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useRef, useState, useEffect } from 'react';
import { useUncontrolled, useDidUpdate } from '@mantine/hooks';
import { useMantineDefaultProps } from '@mantine/styles';
import { ColorSwatch } from '../ColorSwatch/ColorSwatch.js';
import { HueSlider } from './HueSlider/HueSlider.js';
import { AlphaSlider } from './AlphaSlider/AlphaSlider.js';
import { Saturation } from './Saturation/Saturation.js';
import { Swatches } from './Swatches/Swatches.js';
import useStyles from './ColorPicker.styles.js';
import { isColorValid, parseColor } from './converters/parsers.js';
import { convertHsvaTo } from './converters/converters.js';
import { Box } from '../Box/Box.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var SWATCH_SIZES = {
  xs: 26,
  sm: 34,
  md: 42,
  lg: 50,
  xl: 54
};
var defaultProps = {
  swatchesPerRow: 10,
  size: "sm",
  withPicker: true,
  focusable: true,
  __staticSelector: "ColorPicker"
};
var ColorPicker = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("ColorPicker", defaultProps, props),
      value = _a.value,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      format = _a.format,
      swatches = _a.swatches,
      swatchesPerRow = _a.swatchesPerRow,
      size = _a.size,
      withPicker = _a.withPicker,
      fullWidth = _a.fullWidth,
      focusable = _a.focusable,
      __staticSelector = _a.__staticSelector,
      saturationLabel = _a.saturationLabel,
      hueLabel = _a.hueLabel,
      alphaLabel = _a.alphaLabel,
      className = _a.className,
      styles = _a.styles,
      classNames = _a.classNames,
      others = __objRest(_a, ["value", "defaultValue", "onChange", "format", "swatches", "swatchesPerRow", "size", "withPicker", "fullWidth", "focusable", "__staticSelector", "saturationLabel", "hueLabel", "alphaLabel", "className", "styles", "classNames"]);

  var _useStyles = useStyles({
    size: size,
    fullWidth: fullWidth
  }, {
    classNames: classNames,
    styles: styles,
    name: __staticSelector
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var formatRef = useRef(format);
  var valueRef = useRef(null);
  var withAlpha = format === "rgba" || format === "hsla";

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shouldSkip = _useState2[0],
      setShouldSkip = _useState2[1];

  var _useUncontrolled = useUncontrolled({
    value: value,
    defaultValue: defaultValue,
    finalValue: "#FFFFFF",
    rule: function rule(val) {
      return isColorValid(val);
    },
    onChange: onChange
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
      _value = _useUncontrolled2[0],
      setValue = _useUncontrolled2[1];

  var _useState3 = useState(parseColor(_value)),
      _useState4 = _slicedToArray(_useState3, 2),
      parsed = _useState4[0],
      setParsed = _useState4[1];

  var handleChange = function handleChange(color) {
    setShouldSkip(true);
    setParsed(function (current) {
      var next = __spreadValues(__spreadValues({}, current), color);

      valueRef.current = convertHsvaTo(formatRef.current, next);
      return next;
    });
    Promise.resolve().then(function () {
      return setValue(valueRef.current);
    }).then(function () {
      return setShouldSkip(false);
    });
  };

  useEffect(function () {
    if (isColorValid(value) && !shouldSkip) {
      setParsed(parseColor(value));
    }
  }, [value]);
  useDidUpdate(function () {
    formatRef.current = format;
    setValue(convertHsvaTo(format, parsed));
  }, [format]);
  return /* @__PURE__ */React.createElement(Box, __spreadValues({
    className: cx(classes.wrapper, className),
    ref: ref
  }, others), withPicker && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Saturation, {
    value: parsed,
    onChange: handleChange,
    color: _value,
    styles: styles,
    classNames: classNames,
    size: size,
    focusable: focusable,
    saturationLabel: saturationLabel,
    __staticSelector: __staticSelector
  }), /* @__PURE__ */React.createElement("div", {
    className: classes.body
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.sliders
  }, /* @__PURE__ */React.createElement(HueSlider, {
    value: parsed.h,
    onChange: function onChange(h) {
      return handleChange({
        h: h
      });
    },
    size: size,
    styles: styles,
    classNames: classNames,
    focusable: focusable,
    "aria-label": hueLabel,
    __staticSelector: __staticSelector
  }), withAlpha && /* @__PURE__ */React.createElement(AlphaSlider, {
    value: parsed.a,
    onChange: function onChange(a) {
      return handleChange({
        a: a
      });
    },
    size: size,
    color: convertHsvaTo("hex", parsed),
    style: {
      marginTop: 6
    },
    styles: styles,
    classNames: classNames,
    focusable: focusable,
    "aria-label": alphaLabel,
    __staticSelector: __staticSelector
  })), withAlpha && /* @__PURE__ */React.createElement(ColorSwatch, {
    color: _value,
    radius: "sm",
    size: theme.fn.size({
      size: size,
      sizes: SWATCH_SIZES
    }),
    className: classes.preview
  }))), Array.isArray(swatches) && /* @__PURE__ */React.createElement(Swatches, {
    data: swatches,
    onSelect: handleChange,
    style: {
      marginTop: 5
    },
    swatchesPerRow: swatchesPerRow,
    focusable: focusable,
    classNames: classNames,
    styles: styles,
    __staticSelector: __staticSelector
  }));
});
ColorPicker.displayName = "@mantine/core/ColorPicker";
export { ColorPicker };